import { html } from 'lit';
import { t } from 'i18next';
import { createApi } from '../../../utils/fetcher';
import { updateEvent } from '../../../utils/updateEvent';
import { animate, fade } from '@lit-labs/motion';
import '../../../components/textArea';
import '../../../components/button';
export const GiveReply = ({ input, tradeId, setInput, closeReply, tradeToken }) => {
    return html `
    <div
      class="mt-16 flex flex-col"
      ${animate({
        in: fade,
    })}
    >
      ${t('Reply to this feedback')}
      <trust-text-area
        dataTest="reply-text-area"
        autoFocus
        value=${input}
        @input=${(e) => {
        setInput(e.detail);
    }}
        maxLength="2000"
        placeHolder=${t('Write your reply here')}
      >
        <p class="detail text-secondary">
          ${input.length}/2000.
          ${t('This answer will be visible on your profile page')}
        </p>
      </trust-text-area>
      <div class="mt-8 flex justify-end gap-16">
        <div class="flex gap-16">
          <trust-button
            dataTest="cancel-reply"
            small
            quiet
            destructive
            @click="${closeReply}"
            >${t('Cancel')}</trust-button
          >
          <trust-button
            dataTest="submit-reply"
            primary
            small
            ?disabled="${input.length === 0}"
            @click="${async () => {
        await sendInReply(input, tradeId, tradeToken);
        setInput("");
    }}"
          >
            ${t('Submit reply')}
          </trust-button>
        </div>
      </div>
    </div>
  `;
};
const sendInReply = async (input, tradeId, token) => {
    if (tradeId && input.length > 0 && token) {
        await createApi({
            reply: input,
            tradeId
        }, '/replies', window.trustSettings, token);
        dispatchEvent(updateEvent);
    }
    else {
        console.error('Could not send in reply', input, tradeId);
    }
};
//# sourceMappingURL=GiveReply.js.map